import { Subscription } from 'rxjs';
import { StatesService } from './../../services/states.service';
import { Component, OnInit } from '@angular/core';
import { StoreService } from '../../services/store.service';

@Component({
  selector: 'dash-porloja',
  templateUrl: './porloja.component.html',
  styleUrls: ['./porloja.component.scss']
})
export class PorlojaComponent implements OnInit {

  private subscription: Subscription;
  public storeList: any = [];
  public loading: boolean;
  public dateSetup: any;

  constructor(private _storeService: StoreService,
    private _stateService: StatesService) { 
    this.loading = true;
  }

  ngOnInit(): void {
    this.subscription = this._stateService.currentDate.subscribe(res => {
      this.dateSetup = res;
      this._storeService.getStoreSubsidiariesList(this.dateSetup.start_date, this.dateSetup.end_date).subscribe(data => {
        this.storeList = data.stores;
        this.loading = false;
      });
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
